export default {
  methods: {
    clearSession() {
      sessionStorage.removeItem('promoCodes');
      sessionStorage.removeItem('wallets');
    },
  },
};
